export const generatedDocumentDownloads = {
  methods: {
    blobToText(blob) {
      if (!blob) return Promise.resolve("");

      if (typeof blob.text === "function") {
        return blob.text();
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsText(blob);
      });
    },

    async queuedDocumentMessage(blob, fallbackMessage) {
      try {
        const text = await this.blobToText(blob);
        const payload = JSON.parse(text);
        return payload.message || fallbackMessage;
      } catch (error) {
        return fallbackMessage;
      }
    },

    downloadBlob(blob, filename) {
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        const blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", filename);

        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }

        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      }
    },

    openBlob(blob) {
      const fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, "_blank");
    },

    async handleGeneratedDocumentRequest(
      request,
      { filename = null, openInline = false, pendingMessage, errorMessage }
    ) {
      try {
        const response = await request;

        if (response.status === 202) {
          const message = await this.queuedDocumentMessage(
            response.data,
            pendingMessage
          );
          this.$store.dispatch("snackbarSuccess", message);
          return false;
        }

        if (openInline) {
          this.openBlob(response.data);
        } else {
          this.downloadBlob(response.data, filename);
        }

        return true;
      } catch (error) {
        this.$store.dispatch("snackbarError", errorMessage);
        return false;
      }
    },
  },
};

export default {
  generatedDocumentDownloads,
};
